
import { Customer } from './types';

/**
 * Helper function to check if a user is pending with detailed logging
 */
export const isPendingUser = (customer: Customer): boolean => {
  const isPending = (!customer.plan || customer.plan === "pending") && customer.status !== "canceled";
  
  // Detailed logging to help diagnose discrepancies
  if (isPending) {
    console.log('Pending User Diagnostic:', {
      customerId: customer.id,
      plan: customer.plan,
      status: customer.status,
      createdAt: customer.created_at,
      isPending: isPending
    });
  }
  
  return isPending;
};

/**
 * Groups customers by their subscription plan
 */
export const groupCustomersByPlan = (customers: Customer[], beforeDate?: Date) => {
  const filteredCustomers = beforeDate 
    ? customers.filter(customer => new Date(customer.created_at) <= beforeDate)
    : customers;
    
  const pendingCount = filteredCustomers.filter(customer => isPendingUser(customer)).length;
  const monthlyCount = filteredCustomers.filter(c => c.plan === "monthly" && c.status !== "canceled").length;
  const annualCount = filteredCustomers.filter(c => c.plan === "annual" && c.status !== "canceled").length;
  const lifetimeCount = filteredCustomers.filter(c => c.plan === "lifetime" && c.status !== "canceled").length;
  const canceledCount = filteredCustomers.filter(c => c.status === "canceled").length;
  
  return {
    pending: pendingCount,
    monthly: monthlyCount,
    annual: annualCount,
    lifetime: lifetimeCount,
    canceled: canceledCount,
    total: pendingCount + monthlyCount + annualCount + lifetimeCount + canceledCount
  };
};
